import { Calendar } from '@fullcalendar/core';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import luxonPlugin from '@fullcalendar/luxon3';

/**
 * Creates FullCalendar Calendar using supplied parent element and options.
 * Don't forget to call the render() method on it!
 * @param calendarEl - Element to attach FullCalendar to.
 * @param options - Additional options (e.g. 'events' takes a list of events to use).
 * @returns {Calendar} The FullCalendar Calendar instance.
 */
export default function buildCalendar(calendarEl, options) {
  return new Calendar(calendarEl, Object.assign({
    timeZone: 'local',
    plugins: [interactionPlugin, dayGridPlugin, timeGridPlugin, listPlugin, luxonPlugin],
    contentHeight: 'auto', // fix scrollbar
    initialView: 'dayGridMonth',
    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: 'dayGridMonth,timeGridWeek,listWeek',
    },
    datesSet: (dateInfo) => {
      if (dateInfo.view == null) return;

      const { type } = dateInfo.view;
      let message = 'To create an appointment click the New Appointment button or click a date below.';

      if (type === 'timeGridWeek') {
        message = 'To create an appointment click the New Appointment button or click a time under a date.';
      }

      if (type === 'listWeek') {
        message = '';
      }

      $('.calendar-hint').text(message);

      // Patch aria-label on toolbar icon spans to fix axe role-img-alt violation
      calendarEl.querySelectorAll('.fc-toolbar button span[role="img"]').forEach((span) => {
        if (span.classList.contains('fc-icon-chevron-left')) {
          span.setAttribute('aria-label', 'Previous');
        } else if (span.classList.contains('fc-icon-chevron-right')) {
          span.setAttribute('aria-label', 'Next');
        }
      });
    },
  }, options));
}
global.buildCalendar = buildCalendar;
